import * as React from 'react'
import useWindowSize from 'shared/hooks/use-window-size'

function findTextNode(node: Node): Node {
  while (node.hasChildNodes() && node.firstChild!.nodeType !== Node.TEXT_NODE) {
    node = node.firstChild!
  }
  return node
}

// TODO: Move to pretext
export const useIsOverflowText = (
  ref: React.RefObject<HTMLElement>,
  callback?: (hasOverflow: boolean) => void,
): boolean | undefined => {
  const [isOverflow, setIsOverflow] = React.useState<boolean | undefined>(undefined)
  const { width } = useWindowSize()

  React.useLayoutEffect(() => {
    const { current } = ref

    const trigger = (): void => {
      if (!current) return
      const textNode = findTextNode(current) as Element
      if (!textNode) return
      const hasOverflow = textNode.scrollWidth > current.clientWidth

      setIsOverflow(hasOverflow)

      if (callback) callback(hasOverflow)
    }

    if (current) {
      trigger()
    }
  }, [callback, ref, width])

  return isOverflow
}
